import { Component, OnInit } from '@angular/core';
declare const $: any;
import { Translate } from 'src/app/pipe/translate.pipe';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(private translate: Translate) { }

  ngOnInit(): void {
  }

  openModal() {
    $('.modal-work').modal('show');
  }
  getCodeOfEthicsName() {
    let name = this.translate.transform("COD_ETICO_NAME", 'pipeFilter') as string;
    return "../../../assets/download/" + name + ".pdf";
  }

}
